import React from 'react';
import { useUltrapackLicense } from '../../../../../hooks/useUltraPackLicense';
import styles from './UltraPackLicensePrice.module.scss';

const UltraPackLicensePrice = () => {
  const { isUltraPackLicense, formattedTotalPrice, currencyCode } =
    useUltrapackLicense({});

  if (!isUltraPackLicense) {
    return null;
  }

  return (
    <div className={styles.pricing}>
      <span className={styles.price}>{formattedTotalPrice.formattedPrice}</span>
      <span className={styles.currency}>{currencyCode}</span>
      {formattedTotalPrice.geoTaxDisclosure ? (
        <span className={styles.geoTax}>
          {formattedTotalPrice.geoTaxDisclosure}
        </span>
      ) : null}
    </div>
  );
};

export default UltraPackLicensePrice;
